import { Box, Button } from "@mui/material";
import DownloadReport from "../evaluationResults/downloadReport.jsx";
import { useEffect, useState } from "react";
import { useStoreState, useStoreActions } from "easy-peasy";

import { validateNewForm } from "./../../utils/graph-helper";

//  This component handling all the Call to action button are present in the stepper
export const StepperCTA = ({
  activeStep,
  handleNext,
  handleBack,
  stepsLength,
}) => {
  const setNextBtnDisabled = useStoreActions(
    (actions) => actions.setNextBtnDisabled
  );

  /* Validate request type here. */

  const validateField = (name, value) => {
    switch (name) {
      case "thickness":
        // Validation for the 'name' field
        if (value === "" || value == undefined) {
          return false;
        } else if (value < 0.1 || value > 5) {
          return false;
        } else {
          return true;
        }
      case "recycledResinConc":
        // Validation for the 'password' field
        console.log("inside the recycledresin value");
        console.log(value);
        if (value === "" || value == undefined) {
          return false;
        } else if (value < 0 || value > 100) {
          return false;
        } else {
          return true;
        }
      case "resinName":
        // Validation for the 'password' field
        if (value === "" || value == undefined) {
          return false;
        } else if (value < 0 || value > 55) {
          return false;
        } else {
          return true;
        }
      case "fileName":
        // Validation for the 'password' field
        if (value === "" || value == undefined) {
          return false;
        } else {
          return true;
        }
    }
  };

  const validateMainForm = (errors) => {
    const errorRespMainForm = validateNewForm(errors);
    console.log(errorRespMainForm);
    console.log(newFormErrors);
    console.log(errorRespMainForm);
    //alert("here");
    if (errorRespMainForm) {
      /* Check here virgin resin and Recycled resin condition */
      setNextBtnDisabled(false);
    } else {
      setNextBtnDisabled(true);
    }
  };

  let newFormErrors = useStoreState((state) => state.newFormErrors);

  let inputColor = useStoreState((state) => state.inputColor);
  let requirements = useStoreState((state) => state.requirements);
  let setRequirements = useStoreActions((actions) => actions.setRequirements);

  /* code for first Requirement steppeer form */
  const handleRequirementState = () => {
    setRequirements;
  };

  if (activeStep === 0) {
    // Add validation code here
    if (
      requirements?.virginResin === "Characterized Resin" &&
      requirements?.recycledResin === "Characterized Resin"
    ) {
      // check if valiue is field or not if not field then add  inside newFormErrors
      let errors = newFormErrors;
      if (
        requirements.selectedVirginResin === null ||
        requirements.selectedVirginResin == ""
      ) {
        errors["virgin"] = {
          required: true,
          highlight: false,
        };
      }
      validateMainForm(errors);

      if (
        requirements.selectedRecycledResin === null ||
        requirements.selectedRecycledResin == ""
      ) {
        errors["recycled"] = {
          required: true,
          highlight: false,
        };
      }

      /* Make common function*/
    } else if (
      requirements?.virginResin === "New Resin" &&
      requirements?.recycledResin === "Characterized Resin"
    ) {
      /* Skip the virgin resin characjterized option here to disable the button */
      delete newFormErrors.virgin;
      const erroRes = validateNewForm(newFormErrors);
      /* set pop up button status here */
      if (
        erroRes &&
        validateField(
          "resinName",
          requirements?.resinRequirement?.newResinvirgin?.resinName
        ) &&
        validateField(
          "thickness",
          requirements?.resinRequirement?.newResinvirgin?.thickness
        ) &&
        validateField(
          "fileName",
          requirements?.resinRequirement?.newResinvirgin?.fileName
        ) &&
        requirements?.selectedRecycledResin
      ) {
        /* Check here virgin resin and Recycled resin condition */
        // Check here vergin resin all values if all values are empty then disable
        // the button else enable also skip charachterized resin values
        setNextBtnDisabled(false);
      } else {
        setNextBtnDisabled(true);
      }
    } else if (
      requirements?.virginResin === "Characterized Resin" &&
      requirements?.recycledResin === "New Resin"
    ) {
      console.log("here");
      /* Skip the virgin resin characjterized option here to disable the button */
      delete newFormErrors.recycled;
      const erroRes = validateNewForm(newFormErrors);
      console.log(erroRes);
      console.log(erroRes);
      console.log(newFormErrors);
      if (
        erroRes &&
        validateField(
          "resinName",
          requirements?.resinRequirement?.newResinRecycled?.resinName
        ) &&
        validateField(
          "thickness",
          requirements?.resinRequirement?.newResinRecycled?.thickness
        ) &&
        validateField(
          "fileName",
          requirements?.resinRequirement?.newResinRecycled?.fileName
        ) &&
        validateField(
          "recycledResinConc",
          requirements?.resinRequirement?.newResinRecycled?.dilutionDetails
            ?.recycledResinConc
        )
      ) {
        /* Check here virgin resin and Recycled resin condition */
        // Check here vergin resin all values if all values are empty then disable
        // the button else enable also skip charachterized resin values

        setNextBtnDisabled(false);
      } else {
        setNextBtnDisabled(true);
      }
    } else if (
      requirements?.virginResin === "New Resin" &&
      requirements?.recycledResin === "New Resin"
    ) {
      console.log(newFormErrors);
      const erroRes = validateNewForm(newFormErrors);
      console.log(erroRes);
      console.log("inside onchange");
      if (
        erroRes &&
        validateField(
          "resinName",
          requirements?.resinRequirement?.newResinRecycled?.resinName
        ) &&
        validateField(
          "thickness",
          requirements?.resinRequirement?.newResinRecycled?.thickness
        ) &&
        validateField(
          "fileName",
          requirements?.resinRequirement?.newResinRecycled?.fileName
        ) &&
        validateField(
          "recycledResinConc",
          requirements?.resinRequirement?.newResinRecycled?.dilutionDetails
            ?.recycledResinConc
        ) &&
        validateField(
          "resinName",
          requirements?.resinRequirement?.newResinvirgin?.resinName
        ) &&
        validateField(
          "thickness",
          requirements?.resinRequirement?.newResinvirgin?.thickness
        ) &&
        validateField(
          "fileName",
          requirements?.resinRequirement?.newResinvirgin?.fileName
        )
      ) {
        /* Check here virgin resin and Recycled resin condition */
        // Check here vergin resin all values if all values are empty then disable
        // the button else enable also skip charachterized resin values

        setNextBtnDisabled(false);
      } else {
        setNextBtnDisabled(true);
      }
    }
  }

  let nextBtnDisabled = useStoreState((state) => state.nextBtnDisabled);

  if (activeStep === 1) {
    if (inputColor?.fileName === "" && nextBtnDisabled) {
      setNextBtnDisabled(true);
    } else {
      setNextBtnDisabled(false);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        pt: 2,
        ml: "5%",
        mr: "5%",
        mt: "3%",
      }}
    >
      {activeStep == 0 ? (
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          sx={{
            mr: 1,
            width: "216px",
            height: "40px",
            padding: "8px 40px",
            borderRadius: "24px",
            border: "1px solid #385DAE",
            gap: "10px",
            color: "#385DAE",
            textTransform: "none",
            fontFamily: "Source Sans Pro",
          }}
        >
          Cancel
        </Button>
      ) : (
        <Button
          color="inherit"
          onClick={() => handleBack(false)}
          sx={{
            mr: 1,
            width: "216px",
            height: "40px",
            padding: "8px 40px",
            borderRadius: "24px",
            border: "1px solid #385DAE",
            gap: "10px",
            color: "#385DAE",
            textTransform: "none",
            fontFamily: "Source Sans Pro",
            fontWeight: "600",
          }}
        >
          {activeStep === 1 ? "Back" : "Change requirements"}
        </Button>
      )}

      {/* <Box sx={{ flex: "1 1 auto" }} /> */}
      <Box sx={{ flex: "1 1 auto" }} />
      {activeStep == 2 && (
        <>
          <DownloadReport />
        </>
      )}

      <Box sx={{ flex: "1 1 auto" }} />
      <>
        <Button
          onClick={() => handleNext(true)}
          disabled={activeStep === stepsLength - 1 ? false : nextBtnDisabled}
          sx={{
            mr: 1,
            width: "216px",
            height: "40px",
            padding: "8px 40px",
            borderRadius: "24px",
            border: "1px solid #385DAE",
            gap: "10px",
            background: "linear-gradient(90deg, #3A5DAE 0%, #4EC3E0 100%)",
            border: "1px solid",
            color: "#FFFFFF",
            textTransform: "none",
            fontFamily: "Source Sans Pro",
            fontWeight: 600,
          }}
        >
          {/* {activeStep === stepsLength - 1 ? "Start new prediction" : "Next"} */}
          {activeStep === stepsLength - 1
            ? "Start new prediction"
            : activeStep === 0
            ? "Next"
            : "Evaluate"}
        </Button>
      </>
    </Box>
  );
};
